"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistView = void 0;
var ChecklistView;
(function (ChecklistView) {
    ChecklistView["UNKNOWN"] = "UNKNOWN";
    ChecklistView["PROMO"] = "PROMO";
    ChecklistView["CHECKLIST_DIALOG"] = "CHECKLIST_DIALOG";
    ChecklistView["CHECKLIST_COMPLETE"] = "CHECKLIST_COMPLETE";
})(ChecklistView || (exports.ChecklistView = ChecklistView = {}));
